module.exports = __webpack_public_path__ + "static/media/Battery Cap for Truncheon Meter V2.d7855940.webp";